export default {"src":"/login-app/[GIT_HASH]/_next/static/media/bolt.2d9cd8a3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};